import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
// import danDoe from '../../assets/images/dan-doe.jpg';

const AboutSection = styled.section`
  background-color: #111;
  color: #fff;
  padding: 100px 0;
  position: relative;
  overflow: hidden;

  &:before {
    content: '{ }';
    position: absolute;
    font-size: 500px;
    opacity: 0.03;
    font-family: var(--secondary-font-family);
    top: 50%;
    left: -10%;
    transform: translateY(-50%);
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;

  h2 {
    font-family: var(--secondary-font-family);
    margin-bottom: 3rem;
    
    &:before {
      content: '<';
      opacity: 0.5;
      margin-right: 0.5rem;
    }
    
    &:after {
      content: '/>';
      opacity: 0.5;
      margin-left: 0.5rem;
    }
  }
`;

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Content = styled.div`
  p {
    font-size: 1.1rem;
    line-height: 1.8;
    margin-bottom: 1.5rem;
    opacity: 0.8;
    font-family: var(--secondary-font-family);
  }

  .skills {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 2rem;
    justify-content: center;

    @media (max-width: 768px) {
      justify-content: center;
    }
  }

  .skill-tag {
    background: rgba(255, 255, 255, 0.05);
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-family: var(--secondary-font-family);
    font-size: 0.9rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;

    &:hover {
      border-color: var(--primary-color);
      transform: translateY(-2px);
    }
  }
`;

const About: FC = () => {
  const { t } = useTranslation();

  const skills = [
    'JavaScript/TypeScript',
    'React/Next.js',
    // 'Node.js/Express',
    // 'SQL/NoSQL',
    'Git/GitHub',
    // 'DevOps/CI-CD'
  ];

  return (
    <AboutSection id="about">
      <Container>
        <h2>{t('about.title')}</h2>
        <AboutGrid>
          <Content>
            <p>
              {t('about.description1')}
            </p>
            <p>
              {t('about.description2')}
            </p>
            <div className="skills">
              {skills.map((skill, index) => (
                <span key={index} className="skill-tag">
                  {`> ${skill}`}
                </span>
              ))}
            </div>
          </Content>
        </AboutGrid>
      </Container>
    </AboutSection>
  );
};

export default About;